import { render, staticRenderFns } from "./Stats4.vue?vue&type=template&id=e27140a2&"
import script from "./Stats4.vue?vue&type=script&lang=js&"
export * from "./Stats4.vue?vue&type=script&lang=js&"
import style0 from "./Stats4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports